<div fxFlex="100">
    <mat-card class="m-0">
        <mat-card-header class="course-header success">
            <mat-card-title>
                <span class="course-name">{{ title }}</span>
            </mat-card-title>
            <button mat-icon-button (click)="closeDialog()" class="close-button">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>
    </mat-card>


    <div fxLayout="row wrap">
        <div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxFlex.gt-md="20" fxFlex="100" class="p-10">
                <mat-form-field class="quotation-input" appearance="outline" floatLabel="allways">
                    <mat-label>Nombre del archivo</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Nombre del archivo" #input>
                    <mat-icon matSuffix class="search-icon">search</mat-icon>
                </mat-form-field>
            </div>
            <div fxFlex.gt-md="18" fxFlex="100" (click)="uploadFiles()" *ngIf="!onlyRead">
                <button mat-raised-button matTooltip="Subir Archivos a la partida" [matTooltipPosition]="'above'" class="
                          mat-success">
                    <span>Cargar archivos </span>
                    <mat-icon>cloud_upload</mat-icon>
                </button>
            </div>
        </div>
        <div fxFlex="100">
            <div class="table-responsive">
                <table mat-table matSort [dataSource]="dataSource" class="table employee-list no-wrap">
                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            #
                        </th>
                        <td mat-cell *matCellDef="let file; let i = index">
                            {{ i + 1 }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nameFile">
                        <th mat-header-cell *matHeaderCellDef>
                            Nombre del archivo
                        </th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.nameFile }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            Acciones
                        </th>
                        <td mat-cell *matCellDef="let file" class="action-link">
                            <button mat-icon-button matTooltip="Ver Archivo/Descargar" color="primary"
                                (click)="openFile(file)" [matTooltipPosition]="'above'">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="deleteFile(file)"
                                matTooltip="Eliminar Archivo" [matTooltipPosition]="'above'" class="mat-icon-end">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="
                        displayedColumns
                      "></tr>
                    <tr mat-row *matRowDef="
                        let row;
                        columns: displayedColumns
                      "></tr>
                </table>
                <table *ngIf="files.length === 0" class="text-center">
                    <tr>No hay archivos cargados.</tr>
                </table>
            </div>
        </div>
    </div>
</div>